// extracted by mini-css-extract-plugin
export default {"no-of-results":"list-renderer__no-of-results--k5eHf","noOfResults":"list-renderer__no-of-results--k5eHf"};